"use client";

import React from "react";
import { SparkleStarIcon } from "@/components/icons/SparkleStarIcon";
import { ImageIcon } from "@/components/icons/ImageIcon";
import { ListIcon } from "@/components/icons/ListIcon";
import { BookIcon } from "@/components/icons/BookIcon";

function QuickActionButton({
  icon,
  label,
  onClick,
}: {
  icon: React.ReactNode;
  label: string;
  onClick?: () => void;
}) {
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-2 px-3 py-2 rounded-full text-3.5 transition-colors bg-bg-muted text-fg-muted border border-border-subtle hover:bg-bg-elevated hover:border-border-default"
    >
      {icon}
      <span>{label}</span>
    </button>
  );
}

export function QuickActions({
  onSend,
}: {
  onSend: (message: string) => void;
}) {
  return (
    <div className="flex items-center gap-2 px-4 pb-4 flex-wrap">
      <QuickActionButton
        icon={<SparkleStarIcon />}
        label="Surprise me"
        onClick={() => onSend("Surprise me with something interesting!")}
      />
      <QuickActionButton
        icon={<ImageIcon width={14} height={14} />}
        label="How to generate leads?"
        onClick={() => onSend("How to generate leads?")}
      />
      <QuickActionButton
        icon={<ListIcon width={14} height={14} />}
        label="Create a master list"
        onClick={() => onSend("Create a master list")}
      />
      <div className="flex-1" />
      <QuickActionButton
        icon={<BookIcon width={14} height={14} />}
        label="Prompt library"
        onClick={() => onSend("Show me the prompt library")}
      />
    </div>
  );
}
